<template>
  <div class="nettdoc-button" :class="active ? 'nettdoc-active' : ''" @click="active ? $emit('action') : null">
      <p>{{ $t(text) }}</p>
  </div>
</template>

<script>
export default {
  name: 'Button',
  props: {
    text: String,
    active: Boolean
  }
}
</script>

<style lang="scss" scoped>
    .nettdoc-button {
        margin: 20px 16px;
        position: relative;
        height: 50px;
        text-transform: uppercase;
        opacity: 0.2;
        border-radius: 4px;
        background-color: var(--marigold);
        font-size: 16px;
        font-weight: 800;
        line-height: 2.06;
        text-align: center;
        color: var(--white);
        cursor: default;
        p {
            font-family: Raleway;
            position: relative;
            top: 50%;
            transform: translateY(-50%);
        }
    }
    .nettdoc-active {
        opacity: 1;
        cursor: pointer;
        &:hover, &:active, &:focus {
            background-color: var(--charcoal-grey);
        }
    }
</style>